import React, { Component } from 'react';

class NewFooter extends Component {
  render(){
    return (
      <footer style={{width: '100%', ...style.frame}}>
            <div className="footer-container">
              {/*LOGO GRID SECTION*/}
              <div style={{marginBottom: '2rem'}} className="grid">
                <div className="grid__item col-xs-12 col-sm-4">
                  <div className="footer-gray-logo"></div>
                </div>
                {/*GRID INFO SECTION*/}
                <div className="grid__item col-xs-12 col-sm-8">
                  <div className="footer__copy">
                    <p className="footer__copy_p">We pride ourselves in providing luxury, comfort and convenience. Stay with us.</p>
                    <p className="footer__copy_p2"><a>stay@furnishedliving.la</a></p>
                  </div>

                  <div className="footer__contact-info grid grid--mobile">
                    <div className="footer-grid-column">
                      <p className="font-weight-800">Addresses</p>
                      <p className="rem-85">
                        <a>Santa Monica --</a>
                        <br></br>
                        <a>135 Montana Ave</a>
                        <br></br>
                        <a>Santa Monica, CA 90403</a>
                      </p>
                      <br></br>
                      <p className="rem-85">
                        <a>Santa Monica --</a>
                        <br></br>
                        <a>435 Montana Ave</a>
                        <br></br>
                        <a>Santa Monica, CA 90403</a>
                      </p>
                    </div>
                    <div className="footer-grid-column">
                      <p style={{color: 'transparent'}}>Heading</p>
                      <p className="rem-85">
                        <a>West Hollywood --</a>
                        <br></br>
                        <a>8900 Rangely Ave</a>
                        <br></br>
                        <a>West Hollywood, CA 90048</a>
                      </p>
                    </div>
                    <div className="footer-grid-column">
                      <p className="font-weight-800">Social</p>
                      <p className="rem-85">
                        <a>Google</a>
                        <br></br>
                        <a>Facebook</a>
                        <br></br>
                        <a>Trip Advisor</a>
                      </p>
                    </div>
                    <div className="footer-grid-column">
                      <p className="font-weight-800">Contact</p>
                      <p className="rem-85">
                        <a>310.456.3245</a>
                        <br></br>
                        <a>info@furnishedlivingla.com</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            {/*COPYRIGHT SECTION*/}
            <div className="footer__copyright grid">
              <div className="col-sm-4 col-xs-12">
                <p>copyright blueprint</p>
                <p style={{textTransform: 'none'}}>All rights reserved.</p>
              </div>
              <div className="col-sm-8 col-xs-12">
                {/*EXTRA GRID ON BASIC*/}
                <div className="col-xs-12 col-sm-6">
                  <p>
                    <a>Term & Conditions</a>
                  </p>
                </div>
                <div className="col-xs-12 col-sm-6">
                  <p>
                    <a>Privacy Policy</a>
                  </p>
                </div>
              </div>
            </div>

            </div>
      </footer>
    )
  }
}

export default NewFooter;

var style = {
  frame: {
    backgroundColor: '#1b1b1c',
    color: '#fff',
    paddingTop: '8.49618vw',
    paddingBottom: '3.6202vw',
    display: 'table'
  }
}



// WEBPACK FOOTER //
// ./src/NewFooter.js